/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiActionButton,
  ApiActionButtonFromJSON,
  ApiActionButtonFromJSONTyped,
  ApiActionButtonToJSON,
} from './ApiActionButton';
import { ApiEvent, ApiEventFromJSON, ApiEventFromJSONTyped, ApiEventToJSON } from './ApiEvent';
import {
  ApiMicroInteractionSearchItem,
  ApiMicroInteractionSearchItemFromJSON,
  ApiMicroInteractionSearchItemFromJSONTyped,
  ApiMicroInteractionSearchItemToJSON,
} from './ApiMicroInteractionSearchItem';
import {
  ApiNavigation,
  ApiNavigationFromJSON,
  ApiNavigationFromJSONTyped,
  ApiNavigationToJSON,
} from './ApiNavigation';
import { ApiPromo, ApiPromoFromJSON, ApiPromoFromJSONTyped, ApiPromoToJSON } from './ApiPromo';
import {
  ApiSearchCriteria,
  ApiSearchCriteriaFromJSON,
  ApiSearchCriteriaFromJSONTyped,
  ApiSearchCriteriaToJSON,
} from './ApiSearchCriteria';

/**
 *
 * @export
 * @interface ApiScreen
 */
export interface ApiScreen {
  /**
   *
   * @type {string}
   * @memberof ApiScreen
   */
  heading?: string;
  /**
   *
   * @type {ApiSearchCriteria}
   * @memberof ApiScreen
   */
  searchCriteria?: ApiSearchCriteria;
  /**
   *
   * @type {Array<ApiMicroInteractionSearchItem>}
   * @memberof ApiScreen
   */
  items?: Array<ApiMicroInteractionSearchItem>;
  /**
   *
   * @type {ApiPromo}
   * @memberof ApiScreen
   */
  promo?: ApiPromo;
  /**
   *
   * @type {ApiActionButton}
   * @memberof ApiScreen
   */
  button?: ApiActionButton;
  /**
   *
   * @type {string}
   * @memberof ApiScreen
   */
  disclaimer?: string;
  /**
   *
   * @type {ApiNavigation}
   * @memberof ApiScreen
   */
  navigation?: ApiNavigation;
  /**
   *
   * @type {ApiEvent}
   * @memberof ApiScreen
   */
  event?: ApiEvent;
}

export function ApiScreenFromJSON(json: any): ApiScreen {
  return ApiScreenFromJSONTyped(json, false);
}

export function ApiScreenFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreen {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    heading: !exists(json, 'heading') ? undefined : json['heading'],
    searchCriteria: !exists(json, 'searchCriteria')
      ? undefined
      : ApiSearchCriteriaFromJSON(json['searchCriteria']),
    items: !exists(json, 'items')
      ? undefined
      : (json['items'] as Array<any>).map(ApiMicroInteractionSearchItemFromJSON),
    promo: !exists(json, 'promo') ? undefined : ApiPromoFromJSON(json['promo']),
    button: !exists(json, 'button') ? undefined : ApiActionButtonFromJSON(json['button']),
    disclaimer: !exists(json, 'disclaimer') ? undefined : json['disclaimer'],
    navigation: !exists(json, 'navigation') ? undefined : ApiNavigationFromJSON(json['navigation']),
    event: !exists(json, 'event') ? undefined : ApiEventFromJSON(json['event']),
  };
}

export function ApiScreenToJSON(value?: ApiScreen | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    heading: value.heading,
    searchCriteria: ApiSearchCriteriaToJSON(value.searchCriteria),
    items:
      value.items === undefined
        ? undefined
        : (value.items as Array<any>).map(ApiMicroInteractionSearchItemToJSON),
    promo: ApiPromoToJSON(value.promo),
    button: ApiActionButtonToJSON(value.button),
    disclaimer: value.disclaimer,
    navigation: ApiNavigationToJSON(value.navigation),
    event: ApiEventToJSON(value.event),
  };
}
